import NavigationSection from "../navigation-section"
import {LayoutMenuState} from "../../../../layout/layout/const"

// const debug = "navigationStructureOnClick"
const debug = false

export async function navigationStructureOnClick(section:NavigationSection) {

    debug && console.log(debug, "navigationStructureOnClick() section=", section);

    await gd.layout.navigation.openSectionV2(section)

    switch (gd.layout.menuState) {

        case LayoutMenuState.STATIC:
            if (section.defaultAppUrl) {
                // Prevent navigation to defaultAppUrl if it's in the navigation panel.
                // Only auto-navigate if the view is in the menu.
                const navigationStructure = gd.navigationStructure.getByURL(section.defaultAppUrl)
                if (!navigationStructure?.isInNavigation) {
                    gd.navigation.goTo(section.defaultAppUrl, {
                        sameUrlIgnore: true
                    })
                }
            }
            break
    }

    return true
}
